import { render, staticRenderFns } from "./EncounterTreatmentTypeChart.vue?vue&type=template&id=25b82f43&"
import script from "./EncounterTreatmentTypeChart.vue?vue&type=script&lang=js&"
export * from "./EncounterTreatmentTypeChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports